export default {
  name: "toggle_down",
  class: "h-6 w-6",
  box: 24,
  svg: `<path
  stroke-linecap="round"
  stroke-linejoin="round"
  stroke-width="2"
  d="M19 9l-7 7-7-7" stroke="fillcolor"
/>`,
};
